import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { ModalsManager } from '@/components/modals/modalsManager';
import { RoutineLibraryFirstModal } from '@/components/modals/routine-library-first-modal';
import { FEATURES, hasFeature } from '@/features/feature-flags';
import { sendPluginMessage } from '@/plugins/plugin-messages';
import { trackEvent } from '@/utils/analytics';

import { ROUTINE_CHAT_PROMPT } from '../routine-setup-prompt';

export const useCreateRoutineWithLittlebird = () => {
  const navigate = useNavigate();
  // A press still waiting for a plugin to load is dropped when this screen goes, so it opens nothing later
  const dropPending = useRef(() => {});
  useEffect(() => () => dropPending.current(), []);

  return () => {
    trackEvent('ROUTINE_NEW_BUTTON_CLICKED');
    dropPending.current();
    dropPending.current = sendPluginMessage(
      'routine.create',
      { source: 'routines-page' },
      () => {
        if (hasFeature(FEATURES.ROUTINE_LIBRARY_FIRST)) {
          ModalsManager.show(RoutineLibraryFirstModal);
          return;
        }
        navigate({
          to: '/chats',
          search: { auto_prompt: ROUTINE_CHAT_PROMPT },
        });
      }
    );
  };
};
